import React from 'react';

import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import { Box, TopbarWrapper } from '../design/css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const SeatDetailsTable = ({ forms, onDelete, onEdit, isAllValuesNoOdyssey }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    seatDetails: {
      seatInfoHeader,
      deviceTypeHeader,
      creationDateHeader,
      actionsHeader
    },
    formButtons: { deleteButtonLabel, editButtonLabel }
  } = localizedStrings;
  return (
    <Box
      style={{
        marginTop: '20px',
        border: '1px solid #e3e3e3',
        boxShadow: '1px 1px 9px 4px #e3e3e3'
      }}
    >
      <TopbarWrapper
        style={{ color: '#fff' }}
      >{`Office Seats (${forms.length})`}</TopbarWrapper>
      <Table>
        <Thead style={{ background: '#e2e2e2' }}>
          <Tr>
            <Th>#</Th>
            <Th>{seatInfoHeader}</Th>
            {!isAllValuesNoOdyssey &&
            <Th>{deviceTypeHeader}</Th>}
            <Th>{creationDateHeader}</Th>
            <Th>{actionsHeader}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {forms.map((item, index) => {
            const {
              rateCenterProvince,
              rateCenter,
              deviceType,
              creationDate
            } = item;
            const rowKey = `row${index}`;

            return (
              rateCenter && (
                <Tr
                  key={rowKey}
                  style={{
                    background: index % 2 === 0 ? '#f9f1ff' : '#ffffff'
                  }}
                >
                  <Td width="10%">{index + 1}</Td>
                  <Td width="40%">{`${rateCenterProvince}, ${rateCenter}`}</Td>
                  {!isAllValuesNoOdyssey &&
                  <Td width="15%">{deviceType}</Td>}
                  <Td width="15%">
                    {moment(creationDate).format('MM-DD-YYYY HH:mm')}
                  </Td>
                  <Td width="20%">
                    <button
                      type="button"
                      className="btn btn-link"
                      style={{ color: '#4B286D' }}
                      onClick={() => onDelete(index)}
                    >
                      {deleteButtonLabel}
                    </button>
                    |
                    <button
                      type="button"
                      className="btn btn-link"
                      style={{ color: '#4B286D' }}
                      onClick={() => onEdit(index)}
                    >
                      {editButtonLabel}
                    </button>
                  </Td>
                </Tr>
              )
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
};

SeatDetailsTable.propTypes = {
  forms: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      unitPrice: PropTypes.number,
      quantity: PropTypes.number
    })
  ).isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired
};

export default SeatDetailsTable;
